"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GenericFormTranslations = {
    fi: {
        GenericForm: {
            save: 'Tallenna',
            back: 'Takaisin',
            delete: 'Poista',
        },
    },
    en: {
        GenericForm: {
            save: 'Save',
            back: 'Back',
            delete: 'Delete',
        },
    },
};
exports.default = GenericFormTranslations;
//# sourceMappingURL=GenericForm.translation.js.map